import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsBancoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/banco');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Banco');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/banco', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Banco');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/banco', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Banco');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/banco/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Banco');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/banco/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Banco');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/banco/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Banco');
    }
  }
}
